import { useEffect, useMemo, useState } from 'react';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { TableComponentRequestDto } from '@src/api';

type ReportPackages = { code: string; report_group_code: string; year: string };

export const useGetReportPackages = (organizationCode: string): ReportPackages[] => {
  const [reportPackages, setReportPackages] = useState<ReportPackages[]>([]);

  useEffect(() => {
    (async () => {
      if (!organizationCode) return;

      preloaderStore.preloader(true);
      try {
        const response = await cmApi.tableComponentV2.getTableJson({
          fields: ['code', 'report_group_code', 'year'],
          hardFilter: [
            [
              {
                name: 'organization_code',
                type: FILTER.EQ,
                filterIsInverted: false,
                values: [organizationCode],
              },
            ],
          ],
          limit: 10000,
          offset: 0,
          resource: 'cm.report_package',
        } as unknown as TableComponentRequestDto);

        const result = response?.data as unknown as {
          data: { code: string; report_group_code: string; year: string }[];
        };

        if (result) {
          const out = result.data.map((item) => ({
            code: item.code,
            report_group_code: item.report_group_code,
            year: item.year,
          }));

          setReportPackages(out);
        }
      } catch (error) {
        console.error(error);
      } finally {
        preloaderStore.preloader(false);
      }
    })();
  }, [organizationCode]);

  return useMemo(() => reportPackages, [reportPackages]);
};
